import { Reveal, ChapterTag } from "@/components/Reveal";

export const Experience = () => (
  <section id="experience" data-testid="experience-section" className="scroll-mt-24 bg-[#F7F1E6] py-20 sm:py-28 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <ChapterTag number="01" label="The Experience" />
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 max-w-3xl text-[1.9rem] font-extrabold leading-tight tracking-tight text-[#074345] sm:text-4xl lg:text-[2.6rem]">
          Good company. A favorite show. A new snack-time ritual.
        </h2>
      </Reveal>
      <Reveal delay={0.14}>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#243C39] sm:text-lg">
          Movie nights, game days and those just-one-more-episode evenings. We&rsquo;re
          imagining Peanut Valet as a cheerful addition to the moments people already
          love sharing.
        </p>
      </Reveal>
      <Reveal delay={0.1} y={40} className="mt-12">
        <div className="overflow-hidden rounded-[2rem] shadow-[0_40px_80px_-40px_rgba(7,67,69,0.4)]">
          <img
            data-testid="experience-image"
            src="/assets/peanut-valet-family-movie-night.webp"
            srcSet="/assets/peanut-valet-family-movie-night-900.webp 900w, /assets/peanut-valet-family-movie-night.webp 1672w"
            sizes="(max-width: 1280px) 100vw, 1216px"
            alt="Rendered lifestyle scene of a family watching television with Peanut Valet on their coffee table."
            width="1672"
            height="941"
            loading="lazy"
            className="h-auto w-full"
          />
        </div>
        <p className="mt-4 text-sm text-[#506460]" data-testid="experience-caption">
          An illustration of the intended experience. Rendered visual.
        </p>
      </Reveal>
    </div>
  </section>
);
